import { RootSchema } from "../../../redux/reducers";
import { AnalyticsEvent } from "../types";
import { mapStaticMutation } from "./helpers";

export const mapIntegrationsAnalyticsEvents = (previousState: RootSchema, currentState: RootSchema): AnalyticsEvent[] => [
  ...mapStaticMutation(previousState.integrations?.addWebHookResponse, currentState.integrations?.addWebHookResponse, {
    successEventName: "integrations_created_webhook",
    errorEventName: "integrations_got_webhook_error"
  }),
  ...mapStaticMutation(previousState.integrations?.updateWebHookResponse, currentState.integrations?.updateWebHookResponse, {
    successEventName: "integrations_updated_webhook",
    errorEventName: "integrations_got_webhook_error"
  }),
  ...mapStaticMutation(previousState.integrations?.deleteWebHookResponse, currentState.integrations?.deleteWebHookResponse, {
    successEventName: "integrations_deleted_webhook",
    errorEventName: "integrations_got_webhook_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.saveSSOIntegrationData, currentState.platformConfiguration?.saveSSOIntegrationData, {
    successEventName: "integrations_created_sso",
    errorEventName: "integrations_got_sso_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.deleteSSOIntegrationData, currentState.platformConfiguration?.deleteSSOIntegrationData, {
    successEventName: "integrations_deleted_sso",
    errorEventName: "integrations_got_sso_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.postSAMLApps, currentState.platformConfiguration?.postSAMLApps, {
    successEventName: "integrations_created_sso",
    errorEventName: "integrations_got_sso_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.putSAMLApps, currentState.platformConfiguration?.putSAMLApps, {
    successEventName: "integrations_updated_sso",
    errorEventName: "integrations_got_sso_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.deleteSAMLApps, currentState.platformConfiguration?.deleteSAMLApps, {
    successEventName: "integrations_deleted_sso",
    errorEventName: "integrations_got_sso_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.postJWTApps, currentState.platformConfiguration?.postJWTApps, {
    successEventName: "integrations_created_sso",
    errorEventName: "integrations_got_sso_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.putJWTApps, currentState.platformConfiguration?.putJWTApps, {
    successEventName: "integrations_updated_sso",
    errorEventName: "integrations_got_sso_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.deleteJWTApps, currentState.platformConfiguration?.deleteJWTApps, {
    successEventName: "integrations_deleted_sso",
    errorEventName: "integrations_got_sso_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.saveHostedPlugin, currentState.platformConfiguration?.saveHostedPlugin, {
    successEventName: "integrations_updated_sso",
    errorEventName: "integrations_got_sso_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.deleteHostedPlugin, currentState.platformConfiguration?.deleteHostedPlugin, {
    successEventName: "integrations_deleted_sso",
    errorEventName: "integrations_got_sso_error"
  }),
  ...mapStaticMutation(previousState.integrations?.activateIntegration, currentState.integrations?.activateIntegration, {
    successEventName: "integrations_activated_third_party_integration",
    errorEventName: "integrations_got_third_party_integration_error"
  }),
  ...mapStaticMutation(previousState.integrations?.deactivateIntegration, currentState.integrations?.deactivateIntegration, {
    successEventName: "integrations_deactivated_third_party_integration",
    errorEventName: "integrations_got_third_party_integration_error"
  }),
  ...mapStaticMutation(previousState.integrations?.saveIntegrationData, currentState.integrations?.saveIntegrationData, {
    successEventName: "integrations_updated_third_party_integration",
    errorEventName: "integrations_got_third_party_integration_error"
  }),
  ...mapStaticMutation(previousState.integrations?.saveAuditLogConfigResponse, currentState.integrations?.saveAuditLogConfigResponse, {
    successEventName: "integrations_updated_audit_log",
    errorEventName: "integrations_got_audit_log_error",
    trackedEventNames: ["integrations_created_audit_log", "integrations_updated_audit_log", "integrations_got_audit_log_error"]
  }),
  ...mapStaticMutation(previousState.integrations?.resetAuditLogConfigResponse, currentState.integrations?.resetAuditLogConfigResponse, {
    successEventName: "integrations_deleted_audit_log",
    errorEventName: "integrations_got_audit_log_error"
  })
];
